import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-p500',
    styleUrls: ['./error.component.scss'],
    templateUrl: './p500.component.html',
    imports: [TranslatePipe],
})
export class P500Component {
  protected location = inject(Location);
}
